@if (item(); as _item) {
  @let img = _item.img;
  @let icon = _item.icon;
  <button
    class="item item__info"
    [ngClass]="{ 'item--selected': _item.selected }"
    [disabled]="_item.isDisabled"
    (click)="handleItemClick(_item)">
    <div class="item__text-container">
      <div class="item__text-content">
        @if (img) {
          <img
            class="item__img"
            [src]="img"
            alt="theme image" />
        }
        @if (icon) {
          <evc-icon
            size="xs"
            [icon]="icon"
            [ngClass]="{ 'item--warn': _item.isWarn }" />
        }
        <span class="item__name">{{ _item.text | optionalAsync }}</span>
      </div>

      @if (aditionalText(); as _text) {
        <span class="item__additional-text">{{ _text }}</span>
      }
    </div>
    @if (isActionURL(_item)) {
      <evc-icon
        size="xs"
        icon="external-context" />
    }
  </button>
}

@if (badgeItem(); as badge) {
  @if (badge.avatar && badge.avatar.type === 'icon') {
    <button
      [id]="badge.id"
      class="item item__info"
      [ngClass]="{ 'item--selected': selected() }"
      (click)="handleOrganizationClick(badge)">
      <evc-avatar
        size="sm"
        [avatar]="badge.avatar"
        [color]="badge.avatar.color" />
      <div class="item__text-container">
        <span class="item__name">{{ badge.name }}</span>
        @if (aditionalText(); as _text) {
          <span class="item__additional-text">{{ _text }}</span>
        }
      </div>
      @if (externalContext()) {
        <evc-icon
          class="external-context-icon"
          icon="external-context"
          size="xs" />
      }
    </button>
  } @else {
    <button
      [id]="badge.id"
      class="item item--organization"
      [ngClass]="{ 'item--selected': selected() }"
      (click)="handleOrganizationClick(badge)">
      <div class="item__info">
        <evc-avatar
          size="sm"
          [avatar]="badge.avatar" />
        <div class="item__text-container">
          <span class="item__name">{{ badge.name }}</span>
          @if (aditionalText(); as _text) {
            <span class="item__additional-text">{{ _text }}</span>
          }
        </div>
      </div>
    </button>
  }
}
